import 'slick-carousel';

/**
 * モーダル内 slick
 */
export class FacilityFloorMap {
  /**
   * コンストラクタ
   */
  constructor() {

    // 上段のマウスオーバーとクリック挙動
    $('.sec-facilityFloor2__mapLinks li')
      .on('mouseenter', function(){
        const index = $(this).index('.sec-facilityFloor2__mapLinks li');
        $('.sec-facilityFloor2__item').eq(index).addClass('is-active');
      })
      .on('mouseleave', function(){
        const index = $(this).index('.sec-facilityFloor2__mapLinks li');
        $('.sec-facilityFloor2__item').eq(index).removeClass('is-active');
      })
      .on('click', function(){
        // Slick
        const index = $(this).index('.sec-facilityFloor2__mapLinks li');
        const $target = $('.sec-facilityFloor2__modal').eq(index);
        (<any>$('.fn-slickSlider', $target)).slick({ dots: true });
      });

    // 下段のマウスオーバーとクリック挙動
    $('.sec-facilityFloor2__item')
      .on('mouseenter', function(){
        const index = $(this).index('.sec-facilityFloor2__item');
        $('.sec-facilityFloor2__mapLinks li a').eq(index).addClass('is-active');
      })
      .on('mouseleave', function(){
        const index = $(this).index('.sec-facilityFloor2__item');
        $('.sec-facilityFloor2__mapLinks li a').eq(index).removeClass('is-active');
      })
      .on('click', function(){
        // Slick
        const index = $(this).index('.sec-facilityFloor2__item');
        const $target = $('.sec-facilityFloor2__modal').eq(index);
        (<any>$('.fn-slickSlider', $target)).slick({ dots: true });
      });

    // モーダルが閉じたらSlickも破棄する
    $(window).on('modal_close', function(){
      (<any>$('.sec-facilityFloor2 .slick-slider')).slick('unslick');
    });
  }
}
